import MarkdownIt from 'markdown-it'

const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
  typographer: true
})

export function detectContentFormat(content) {
  if (!content || typeof content !== 'string') {
    return 'plain'
  }

  const trimmedContent = content.trim()
  
  const htmlPatterns = [
    /<\/?[a-z][\s\S]*>/i,
    /<!DOCTYPE/i,
    /<html/i,
    /<body/i,
    /<div/i,
    /<p>/i,
    /<br\s*\/?>/i,
    /<span/i,
    /<img/i,
    /<a\s+href/i,
    /<h[1-6]/i,
    /<ul>/i,
    /<ol>/i,
    /<li>/i,
    /<table/i,
    /<thead/i,
    /<tbody/i,
    /<tr>/i,
    /<td>/i,
    /<th>/i,
    /<blockquote>/i,
    /<pre>/i,
    /<code>/i,
    /<strong>/i,
    /<em>/i,
    /<b>/i,
    /<i>/i,
    /<u>/i,
    /&[a-z]+;/i,
    /&#\d+;/i,
    /&#x[a-f0-9]+;/i
  ]
  
  for (const pattern of htmlPatterns) {
    if (pattern.test(trimmedContent)) {
      return 'html'
    }
  }
  
  const markdownPatterns = [
    /^#{1,6}\s+/m,
    /^\*{3,}$/m,
    /^-{3,}$/m,
    /^_{3,}$/m,
    /^\* .+$/m,
    /^- .+$/m,
    /^\+ .+$/m,
    /^\d+\. .+$/m,
    /\*\*[^*]+\*\*/,
    /__[^_]+__/,
    /\*[^*\s][^*]*[^*\s]\*/,
    /_[^_\s][^_]*[^_\s]_/,
    /\[([^\]]+)\]\(([^)]+)\)/,
    /!\[([^\]]*)\]\(([^)]+)\)/,
    /^>\s+/m,
    /```[\s\S]*?```/,
    /`[^`]+`/,
    /^\|.*\|$/m,
    /\n\s*\n/,
    /~~[^~]+~~/,
    /\^\^[^^]+\^\^/,
    /==[^=]+==/,
    /\+\+[^+]+\+\+/,
    /--[^-]+--/,
    /^\[\^[^\]]+\]:/m,
    /\[\^[^\]]+\]/
  ]
  
  let markdownScore = 0
  for (const pattern of markdownPatterns) {
    if (pattern.test(trimmedContent)) {
      markdownScore++
    }
  }
  
  if (markdownScore >= 2) {
    return 'markdown'
  }
  
  if (markdownScore === 1) {
    const lines = trimmedContent.split('\n')
    if (lines.length > 1) {
      return 'markdown'
    }
  }
  
  return 'plain'
}

export function formatContent(content, format = null) {
  if (!content) {
    return ''
  }

  const detectedFormat = format || detectContentFormat(content)
  
  switch (detectedFormat) {
    case 'html':
      return content
    
    case 'markdown':
      return md.render(content)
    
    case 'plain':
    default:
      const escaped = content
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;')
      
      return escaped.replace(/\n/g, '<br>')
  }
}

export function renderFormattedContent(content) {
  const format = detectContentFormat(content)
  const formatted = formatContent(content, format)
  
  return {
    format,
    html: formatted
  }
}